import { newSpecPage } from '@stencil/core/testing';
import { LabDsTooltip } from './lab-ds-tooltip';

describe('v4-tooltip', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [LabDsTooltip],
      html: `<lab-ds-tooltip label="Este é o texto da tooltip" />`,
    });
    expect(page.root).toEqualHtml(`
    <lab-ds-tooltip label="Este é o texto da tooltip">
        <mock:shadow-root>
        <div class="five-hours v4-tooltip">
            <div class="tooltip-trigger">
                <slot></slot>
            </div>
            <div class="tooltip-container">
              <div class="label">
                Este é o texto da tooltip
              </div>
              <div class="triangle"></div>
            </div>
        </div>
       </mock:shadow-root>
    </lab-ds-tooltip>
  `);
  });
});
